var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26536 9.66732L0.332031 8.73398L4.06536 5.00065L0.332031 1.26732L1.26536 0.333984L4.9987 4.06732L8.73203 0.333984L9.66536 1.26732L5.93203 5.00065L9.66536 8.73398L8.73203 9.66732L4.9987 5.93398L1.26536 9.66732Z",
    fill: "#1D4650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseV2);
export default __webpack_public_path__ + "static/media/closeV2.fcf254cae28da59e679fd322316e3e05.svg";
export { ForwardRef as ReactComponent };